<template>
  <section class="page">
    <HomeHero></HomeHero>
    <div id="stat-panel" class="level has-text-centered">
      <div class="level-item">
        <div>
          <p class="heading">Records</p>
          <p class="title">{{ $store.getters.recordCount }}</p>
        </div>
      </div>
      <div class="level-item">
        <div>
          <p class="heading">Directories</p>
          <p class="title">{{ $store.getters.directoryCount }}</p>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns is-multiline is-vcentered">
        <router-link
          :to="directory.slug"
          :class="`column
            ${ directory.id != 4
            && directory.id % 2 == 0 || directory.id % 3 == 0 ? 'is-7' : 'is-5' }
            has-text-centered
          `"
          v-for="directory in $store.state.directories"
          :key="directory.id"
        >
          <div :style="'background-image:url(' + directory.hero_uri + ')'" class="directory">
            <h3 class="title has-text-white is-unselectable">{{ directory.name }}</h3>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable import/no-unresolved */
import HomeHero from '@/components/HomeHero.vue';

export default {
  components: {
    HomeHero,
  },
  mounted() {
    this.$store.dispatch('getRecordCount');
  },
};
</script>
